module.exports = __webpack_public_path__ + "static/media/SMS.59df971a.png";